"use client";

import { FaBars } from "react-icons/fa6";
import { Brand } from "./HeaderBar";
import { FaSearch } from "react-icons/fa";
import { useState } from "react";
import { IoClose } from "react-icons/io5";
import { Links } from "./Links";
import { Search } from "./Elements";

export const Mobile = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchOpen, setSearchOpen] = useState(false);
    return (
        <>
            <div className={`sticky top-0 flex md:hidden items-center justify-evenly bg-gray-900 z-50 py-6`}>
                {
                    searchOpen ? (
                        <div className="w-[75%]">
                            <Search />
                        </div>
                    ) : (
                        <>
                            <button className="text-2xl" onClick={() => setIsOpen(!isOpen)}>
                                {
                                    isOpen ? <IoClose /> : <FaBars />
                                }
                            </button>
                            <div className="flex flex-col gap-y-2">
                                <Brand />
                            </div>
                        </>
                    )
                }
                <button className="text-2xl" onClick={() => setSearchOpen(!searchOpen)}>
                    {
                        searchOpen ? <IoClose /> : <FaSearch />
                    }
                </button>
            </div >
            {
                isOpen && (
                    <>
                        <div className="md:hidden fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-[100]" onClick={() => setIsOpen(false)}>
                        </div>
                        <div className="md:hidden fixed top-0 left-0 flex flex-col gap-y-4 h-full w-fit pl-6 pr-16 py-8 bg-gray-900 z-[101]">
                            <button className="text-3xl">
                                <IoClose />
                            </button>
                            <div className="flex flex-col gap-y-4 px-8">
                                <Links />
                            </div>
                        </div>
                    </>
                )
            }
        </>
    );
};